const REGEX_EMPTY_MESSAGE = /\s|&nbsp;|<p>|<br>|<\/p>/ig

/**
 * Check message is empty
 * @param {string} message
 *
 * @returns {boolean}
 */
export function isMessageEmpty(message = '') {
  if (!message) return true
  if (typeof message !== 'string') return true

  return message.replace(REGEX_EMPTY_MESSAGE, '') === ''
}

/**
 * Check disabled composer for chatweb
 * @param {object} params
 * @param {string} params.channel
 * @param {boolean} [params.isOnline]
 * @param {boolean} [params.isWallEnabledForSMS]
 *
 * @returns {boolean}
 */
export function isDisabledComposerForChatweb(params) {
  const { isOnline, isWallEnabledForSMS, channel } = params

  if (channel !== 'chatweb') return false
  if (!isOnline && !isWallEnabledForSMS) return true

  return false
}

/**
 * Check disabled composer for chatmail
 * @param {object} params
 * @param {string} params.provider
 * @param {string} params.messageType
 * @param {string} [params.subjectId]
 * @param {{ chips: [] }} [params.to]
 *
 * @returns {boolean}
 */
export function isDisabledForChatmail(params) {
  const { to = {}, subjectId = '', provider, messageType } = params

  if (provider !== 'chatmail') return false
  if (!to?.chips?.length && messageType !== 'note') return true
  if (!subjectId) return true

  return false
}

/**
 * Check button send is disabled
 * @param {object} params
 * @param {string} [params.message]
 * @param {[object]} [params.attachments]
 * @param {[object]} [params.buttons]
 * @param {string} [params.conversationState]
 * @param {string} [params.messageType]
 * @param {boolean} [params.isLoading]
 * @param {boolean} [params.isDisabledChatweb]
 * @param {boolean} [params.isDisabledChatmail]
 *
 * @returns {boolean}
 */
export function isDisabledSend(params) {
  const {
    message = '', attachments = [], buttons = [], conversationState = '',
    isDisabledChatweb = false, isDisabledChatmail = false, messageType = '',
    isLoading = false
  } = params

  if (isLoading) return true

  const isMsgEmpty = isMessageEmpty(message)
  const btnSize = buttons?.length || 0

  if (isMsgEmpty && !attachments.length && !btnSize) return true
  if (attachments.some(attachment => attachment.withVirus)) return true
  if (btnSize && isMsgEmpty) return true
  if (conversationState === 'nauta') return true
  if (isDisabledChatweb && messageType === 'note' && !isMsgEmpty) return false
  if (isDisabledChatweb || isDisabledChatmail) return true

  return false
}
